const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const SENTRY_PROJECT = process.env.NEXT_PUBLIC_SENTRY_PROJECT
const SENTRY_URL = process.env.NEXT_PUBLIC_SENTRY_URL
const SENTRY_TRACERATE = process.env.NEXT_PUBLIC_SENTRY_TRACERATE ?? '0.1'
const SENTRY_IGNORE_CONSOLE = process.env.NEXT_PUBLIC_SENTRY_IGNORE_CONSOLE ?? 'true'

module.exports = {
    SENTRY_DSN,
    SENTRY_PROJECT,
    SENTRY_URL,
    SENTRY_TRACERATE,
    SENTRY_IGNORE_CONSOLE,
}
